import { apiSlice } from "./apiSlice";

export const publicApiSlice = apiSlice.injectEndpoints({
  tagTypes: [
    "Otp",
    "Register",
    "RegisterWithBank",
    "PublicBonusList",
    "PublicBonusDetails",
    "CommonBackground",
    "DepositCategory",
    "ForgotPassword",
    "ResetPassword",
    "Language",
    "PageContent",
    "Script",
    "CryptoAmount",
    "AddFingerprint",
    "RegisterPopup",
    "WhatsappGroup"
  ],
  endpoints: (builder) => ({
    getOtp: builder.query({
      query: (recipient) => ({
        url: `public/api/v1/getOtp?recipient=${recipient}`,
      }),
      providesTags: ["Otp"],
    }),
    registerAccount: builder.mutation({
      query: (account) => ({
        url: "/public/api/v1/register",
        method: "POST",
        body: account,
      }),
      providesTags: ["Register"],
      invalidatesTags: ["Profile", "BonusList", "GameCategory"],
    }),
    registerAccountWithBank: builder.mutation({
      query: (account) => ({
        url: "/public/api/v1/registerWithBank",
        method: "POST",
        body: account,
      }),
      providesTags: ["RegisterWithBank"],
      invalidatesTags: ["Profile", "BonusList", "GameCategory"],
    }),
    getPublicBonusList: builder.query({
      query: (category) => ({
        url: `public/api/v1/bonusList?category=${category}`,
      }),
      providesTags: ["PublicBonusList"],
    }),
    getPublicBonusDetails: builder.query({
      query: (bonusCode) => `/public/api/v1/bonusDetails/${bonusCode}`,
      providesTags: ["PublicBonusDetails"],
    }),
    getCommonBackground: builder.query({
      query: () => ({
        url: `public/api/v1/commonBackground`,
      }),
      providesTags: ["CommonBackground"],
    }),
    getDepositCategory: builder.query({
      query: () => ({
        url: `public/api/v1/depositCategory`,
      }),
      providesTags: ["DepositCategory"],
    }),
    getForgotPassword: builder.query({
      query: (email) => ({
        url: `public/api/v1/forgotPassword?email=${email}`,
      }),
      providesTags: ["ForgotPassword"],
    }),
    resetPassword: builder.mutation({
      query: (resetDetails) => ({
        url: `public/api/v1/resetPassword`,
        method: "POST",
        body: resetDetails,
      }),
      providesTags: ["ResetPassword"],
    }),
    getLanguages: builder.query({
      query: () => ({
        url: `public/api/v1/languages`,
      }),
      providesTags: ["Language"],
    }),
    getPublicBankAccounts: builder.query({
      query: () => "/public/api/v1/listBankAccounts",
      providesTags: ["BankAccounts"],
    }),
    forgotPasswordSendPhoneOtp: builder.query({
      query: (phoneNumber) => ({
        url: `public/api/v1/forgotPasswordSendPhoneOtp?phoneNumber=${phoneNumber}`,
      }),
      providesTags: ["SendPhoneOtp"],
    }),
    forgotPasswordValidatePhoneOtp: builder.query({
      query: ({ phoneNumber, otp }) => ({
        url: `public/api/v1/forgotPasswordValidatePhoneOtp?phoneNumber=${phoneNumber}&Otp=${otp}`,
      }),
      providesTags: ["ValidatePhoneOtp"],
    }),
    getPageContent: builder.query({
      query: (url) => ({
        url: `/public/api/v1/getPageContent?url=${encodeURIComponent(url)}`,
      }),
      providesTags: ["PageContent"],
    }),
    getLiveMatches: builder.query({
      query: () => ({
        url: `public/api/v1/getLiveMatches`,
      }),
      providesTags: ["LiveMatches"],
    }),
    launchDemoGame: builder.query({
      query: ({ category, type, gameProductCode, gameName, isMobile }) => ({
        url: `public/api/v1/launchDemoGame?category=${category}&type=${type}&gameProductCode=${gameProductCode}&gameName=${gameName}&isMobile=${isMobile}`,
      }),
      providesTags: ["LaunchDemoGame"],
    }),
    getScript: builder.query({
      query: ({ type }) => ({
        url: `public/api/v1/getGlobalScript`,
        method: 'GET',
        params: { type },
      }),
      providesTags: ['Script'],
    }),
    getCryptoAmount: builder.query({
      query: ({ bankCode, amount, paymentGateway }) => ({
        url: `/public/api/v1/getCryptoAmount`,
        params: {
          bankCode,
          amount,
          paymentGateway,
        },
      }),
      providesTags: ["CryptoAmount"],
    }),
    addFingerprint: builder.mutation({
      query: (fingerprint) => ({
        url: `/public/api/v1/addFingerprint`,
        method: "POST",
        body: fingerprint,
      }),
      providesTags: ["AddFingerprint"],
    }),
    getVipRankDetails: builder.query({
      query: () => "/public/api/v1/getVipRankDetails",
      providesTags: ["VipDetails"],
    }),
    getRegisterPopup: builder.query({
      query: () => "/public/api/v1/registerPopup",
      providesTags: ["RegisterPopup"],
    }),
    getWhatsappGroup: builder.query({
      query: () => "/public/api/v1/getWhatsappGroup",
      providesTags: ["WhatsappGroup"],
    }),
  }),
});

export const {
  useLazyGetOtpQuery,
  useRegisterAccountMutation,
  useRegisterAccountWithBankMutation,
  useLazyGetPublicBonusListQuery,
  useLazyGetPublicBonusDetailsQuery,
  useGetCommonBackgroundQuery,
  useGetDepositCategoryQuery,
  useLazyGetForgotPasswordQuery,
  useResetPasswordMutation,
  useGetLanguagesQuery,
  useGetPublicBankAccountsQuery,
  useLazyForgotPasswordSendPhoneOtpQuery,
  useLazyForgotPasswordValidatePhoneOtpQuery,
  useGetPageContentQuery,
  useGetLiveMatchesQuery,
  useLazyLaunchDemoGameQuery,
  useGetScriptQuery,
  useLazyGetCryptoAmountQuery,
  useAddFingerprintMutation,
  useGetVipRankDetailsQuery,
  useLazyGetRegisterPopupQuery,
  useGetWhatsappGroupQuery,
} = publicApiSlice;
